<div class="settings-navigation" data-test="settings-navigation">
  <nav mat-tab-nav-bar [mat-stretch-tabs]="false" [tabPanel]="tabPanel" color="accent">
    <a mat-tab-link [routerLink]="['/settings', 'barn']" [active]="isBarn$ | async">
      {{ 'settings.navigation.barns' | translate }}
    </a>
    <a
      *ngIf="showSustainability$ | async"
      mat-tab-link
      [routerLink]="['/settings', 'sustainability']"
      [active]="isSustainability$ | async"
    >
      {{ 'settings.navigation.sustainability' | translate }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
